import { render } from "./GuideDetail.vue?vue&type=template&id=3b7f937b"
import script from "./GuideDetail.vue?vue&type=script&lang=js"
export * from "./GuideDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__